export default class CMSUser {
    constructor() {
      const whoamiEndpoint = '/authentication/whoami';
      const groupEndpoint = '/users/groups';
      const toolGroups = {
        accessibility: { name: '_tool-accessibility', filePrefix: '' },
        devAccessibility: { name: 'testdev_tool-accessibility', filePrefix: 'dev/' }
      };
      let userName = null;
      let groups = [];
  
      // private methods
  
      let retrieveUserName = function () {
        return new Promise((resolve) => {
          window.parent.fetch(whoamiEndpoint)
            .then(function (response) {
              return response.json();
            })
            .then(function (jsonedResponse) {
              if (typeof (jsonedResponse.user.username) !== "undefined") {
                userName = jsonedResponse.user.username;
                console.log(userName);
                resolve(true);
              }
            }.bind(this));
        });
      }.bind(this);
  
      let retrieveGroups = function () {
        return new Promise((resolve) => {
          console.log(userName);
          window.parent.fetch(groupEndpoint + '?user=' + userName)
            .then(function (response) {
              return response.json();
            })
            .then(function (jsonedResponse) {
              if (typeof (jsonedResponse.groups) !== "undefined") {
                let inGroups = jsonedResponse.groups;
                let tools = Object.values(toolGroups);
                tools = tools.map(tool => tool.name);
                console.log(tools);
                console.log(inGroups);
                groups = tools.filter(value => inGroups.includes(value));
                console.log(groups);
                resolve();
              }
            }.bind(this));
        });
      }.bind(this);
  
      // public methods
  
      this.checkAccessibility = function () {
        console.log(groups);
        let matchedGroups = Object.values(toolGroups).filter(tool => groups.includes(tool.name));
        console.log(matchedGroups);
        if (matchedGroups.length > 0) {
          return true;
        } else {
          return false;
        }
      }.bind(this);
  
      this.filePrefix = function () {
        let prefixes = groups.map(groupName => {
          let tools = Object.values(toolGroups);
          let groupTool = tools.filter(tool => tool.name == groupName);
          console.log(groupTool);
          return groupTool[0].filePrefix;
        });
        console.log(groups);
        console.log(toolGroups);
        console.log(prefixes);
        return prefixes.join('');
      }.bind(this);
  
      this.initUser = function () {
        return new Promise(function (resolve) {
  
          retrieveUserName()
            .then(function () {
              return retrieveGroups();
            })
            .then(function () {
              resolve();
            });
        }.bind(this));
      }.bind(this);
  
  
      // constructor actions:
  
    }
  }